module.exports = __webpack_public_path__ + "img/IMG_6726_FoamcoreMatted.aa72757a.jpg";